import register from '@kpsys/angularjs-register';
import filterModule from '../filters/filters.module';
import providersModule from '../providers/providers.module';
import servicesModule from '../services/services.module';
import {valueEditorsRegistrationConfig} from './value-editors-registration.config';
import {ValueEditorTypeResolutionService} from './kp-value-editor/value-editor-type-resolution.service';
import {ValueEditorConfigurationManagerProvider} from './configuration/value-editor-configuration-manager.provider';
import {ValueEditorAliasesService} from './aliases/value-editor-aliases.service';
import {ValueEditorLocalizationManagerProvider} from './localizations/value-editor-localization-manager.provider';
import {KpUniversalFormConfigurationService} from './kp-universal-form/kp-universal-form-configuration.service';
import {KpValueEditorConfigurationService} from './kp-value-editor/kp-value-editor-configuration.service';
import {ErrorMessagesLocalizationService, VALUE_EDITOR_DEFAULT_ERROR_MESSAGES_LOCALIZATIONS} from './internal/errors/error-messages-localization.service';
import {ValueEditorRegistrationService} from './editor-type-registration/value-editor-registration.service';
import coreModule from 'core/core.module';


export default register('portaro.shared.value-editors.base', [coreModule, filterModule, providersModule, servicesModule])
    .constant('valueEditorDefaultErrorMessagesLocalizations', VALUE_EDITOR_DEFAULT_ERROR_MESSAGES_LOCALIZATIONS)
    .service(ValueEditorRegistrationService.serviceName, ValueEditorRegistrationService)
    .service(ValueEditorAliasesService.serviceName, ValueEditorAliasesService)
    .service(ValueEditorTypeResolutionService.serviceName, ValueEditorTypeResolutionService)
    .service(ValueEditorConfigurationManagerProvider.serviceName, ValueEditorConfigurationManagerProvider)
    .service(ValueEditorLocalizationManagerProvider.serviceName, ValueEditorLocalizationManagerProvider)
    .service(KpValueEditorConfigurationService.serviceName, KpValueEditorConfigurationService)
    .service(KpUniversalFormConfigurationService.serviceName, KpUniversalFormConfigurationService)
    .service(ErrorMessagesLocalizationService.serviceName, ErrorMessagesLocalizationService)
    .run(valueEditorsRegistrationConfig)
    .name();